import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'; // Ensure this line points to the correct CSS file if renamed.
import App from './App';
// import reportWebVitals from './reportWebVitals'; // Comment or remove this line if reportWebVitals.js is deleted.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// reportWebVitals(); // Comment or remove this line if you removed the import.
